module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress",
    class: [_vm.progressSize, _vm.isVertical ? 'vertical' : '', _vm.isActive ? 'active' : '']
  }, [_c('div', {
    staticClass: "progress-bar",
    class: [("progress-bar-" + _vm.type), (_vm.isStriped ? 'progress-bar-striped' : '')],
    style: (((_vm.isVertical?'height':'width') + ": " + _vm.value + "%")),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.value,
      "aria-valuemin": _vm.min,
      "aria-valuemax": _vm.max
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26dec8c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAProgressBar.vue
// module id = 501
// module chunks = 1